export default __webpack_public_path__ + "static/interUI-369733cbe7af08a152d77fec046848c8.svg";